"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationHelperApi = exports.MigrationHelperApiFactory = exports.MigrationHelperApiFp = exports.MigrationHelperApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MigrationHelperApi - axios parameter creator
 * @export
 */
const MigrationHelperApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [companyId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyIdToCompanyReference: (companyId_1, ...args_1) => __awaiter(this, [companyId_1, ...args_1], void 0, function* (companyId, options = {}) {
            const localVarPath = `/migrationHelper/convertCompanyIdToCompanyReference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyReferenceToCompanyId: (companyReference_1, ...args_2) => __awaiter(this, [companyReference_1, ...args_2], void 0, function* (companyReference, options = {}) {
            const localVarPath = `/migrationHelper/convertCompanyReferenceToCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyReference !== undefined) {
                localVarQueryParameter['companyReference'] = companyReference;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperGetKnownCompanyReferenceMappingsMappings: (...args_3) => __awaiter(this, [...args_3], void 0, function* (options = {}) {
            const localVarPath = `/migrationHelper/knownCompanyReferenceMappingsMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MigrationHelperApiAxiosParamCreator = MigrationHelperApiAxiosParamCreator;
/**
 * MigrationHelperApi - functional programming interface
 * @export
 */
const MigrationHelperApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MigrationHelperApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [companyId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyIdToCompanyReference(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperCompanyIdToCompanyReference(companyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationHelperApi.migrationHelperCompanyIdToCompanyReference']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [companyReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyReferenceToCompanyId(companyReference, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperCompanyReferenceToCompanyId(companyReference, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationHelperApi.migrationHelperCompanyReferenceToCompanyId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperGetKnownCompanyReferenceMappingsMappings(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperGetKnownCompanyReferenceMappingsMappings(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationHelperApi.migrationHelperGetKnownCompanyReferenceMappingsMappings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.MigrationHelperApiFp = MigrationHelperApiFp;
/**
 * MigrationHelperApi - factory interface
 * @export
 */
const MigrationHelperApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MigrationHelperApiFp)(configuration);
    return {
        /**
         *
         * @param {MigrationHelperApiMigrationHelperCompanyIdToCompanyReferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyIdToCompanyReference(requestParameters = {}, options) {
            return localVarFp.migrationHelperCompanyIdToCompanyReference(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrationHelperApiMigrationHelperCompanyReferenceToCompanyIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperCompanyReferenceToCompanyId(requestParameters = {}, options) {
            return localVarFp.migrationHelperCompanyReferenceToCompanyId(requestParameters.companyReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperGetKnownCompanyReferenceMappingsMappings(options) {
            return localVarFp.migrationHelperGetKnownCompanyReferenceMappingsMappings(options).then((request) => request(axios, basePath));
        },
    };
};
exports.MigrationHelperApiFactory = MigrationHelperApiFactory;
/**
 * MigrationHelperApi - object-oriented interface
 * @export
 * @class MigrationHelperApi
 * @extends {BaseAPI}
 */
class MigrationHelperApi extends base_1.BaseAPI {
    /**
     *
     * @param {MigrationHelperApiMigrationHelperCompanyIdToCompanyReferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperCompanyIdToCompanyReference(requestParameters = {}, options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperCompanyIdToCompanyReference(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrationHelperApiMigrationHelperCompanyReferenceToCompanyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperCompanyReferenceToCompanyId(requestParameters = {}, options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperCompanyReferenceToCompanyId(requestParameters.companyReference, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperGetKnownCompanyReferenceMappingsMappings(options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperGetKnownCompanyReferenceMappingsMappings(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MigrationHelperApi = MigrationHelperApi;
//# sourceMappingURL=migration-helper-api.js.map